import { ControlFactoryProperty } from '../enums';

const ControlFactoryProps = {
  props: {
    [ControlFactoryProperty.Type]: {
      required: true,
      type: String,
    },
    [ControlFactoryProperty.ControlProps]: {
      required: true,
      type: Object,
    },
  },
};

export default ControlFactoryProps;
